import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CARDS_ROUTE_PATHS } from '../config';

export const DEBIT_CARD_ABM_ROUTES: TApplicationRoute[] = [
  {
    id: 'debit-card-abm',
    path: CARDS_ROUTE_PATHS.debitCardAbm,
    component: lazy(() => import('./pages/debit-card-abm-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['debit-card-abm'] },
    menu: {
      title: 'Debit Card ABM',
    },
  },
];
